<div class="radio-buttons">
  <div *ngFor="let item of dataList">
    <input (click)="toggleChange(item.value);" type="radio" [id]='"radio-button-"+item.value' [checked]="selectedValue == item.value ? true : null"/>
    <label [for]='"radio-button-"+item.value'>{{item.text}}</label>
  </div>
</div>